export default "__VITE_ASSET__DeVDLDu3__"